/**
 * @generated SignedSource<<93cb17b0d1bd622b684c062950cffb20>>
 * @relayHash 9bc759740b757fa71466e3102f83699b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 65d181f4ba6169b348e6d53031c7d6ed7a6d8f25f1dc03df19467bbe1ac7e97b

import type { ConcreteRequest } from 'relay-runtime';
export type TeamMembershipSettings = "EXTERNAL" | "MEMBER_INVITE" | "OPEN" | "ORG_ADMIN_MANAGED" | "%future added value";
export type TeamStateV2 = "ACTIVE" | "DISBANDED" | "PURGED" | "%future added value";
export type archiveTeamsCardQuery$variables = {
  membersCount: number;
  siteId: string;
  teamIds: ReadonlyArray<string | null>;
};
export type archiveTeamsCardQuery$data = {
  readonly team: {
    readonly teamsV2: ReadonlyArray<{
      readonly description: string | null;
      readonly displayName: string | null;
      readonly id: string;
      readonly isVerified: boolean | null;
      readonly largeAvatarImageUrl: string | null;
      readonly members: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly member: {
              readonly accountId: string;
              readonly name: string;
              readonly picture: AGG$URL;
            } | null;
          } | null;
        } | null> | null;
      } | null;
      readonly membershipSettings: TeamMembershipSettings | null;
      readonly organizationId: string | null;
      readonly state: TeamStateV2 | null;
      readonly type: {
        readonly name: string;
      } | null;
    } | null> | null;
  } | null;
};
export type archiveTeamsCardQuery = {
  response: archiveTeamsCardQuery$data;
  variables: archiveTeamsCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membersCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v3 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "teamIds"
  },
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "siteId"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v6 = {
  "kind": "ScalarField",
  "name": "description"
},
v7 = {
  "kind": "ScalarField",
  "name": "state"
},
v8 = {
  "kind": "ScalarField",
  "name": "membershipSettings"
},
v9 = {
  "kind": "ScalarField",
  "name": "organizationId"
},
v10 = {
  "kind": "ScalarField",
  "name": "isVerified"
},
v11 = {
  "kind": "ScalarField",
  "name": "largeAvatarImageUrl"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "membersCount"
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v15 = {
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "archiveTeamsCardQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "TeamV2",
            "kind": "LinkedField",
            "name": "teamsV2",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "concreteType": "TeamType",
                "kind": "LinkedField",
                "name": "type",
                "plural": false,
                "selections": [
                  (v12/*: any*/)
                ]
              },
              {
                "args": (v13/*: any*/),
                "concreteType": "TeamMemberConnectionV2",
                "kind": "LinkedField",
                "name": "members",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamMemberEdgeV2",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TeamMemberV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "member",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v12/*: any*/),
                              (v15/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "archiveTeamsCardQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "TeamV2",
            "kind": "LinkedField",
            "name": "teamsV2",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "concreteType": "TeamType",
                "kind": "LinkedField",
                "name": "type",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "args": (v13/*: any*/),
                "concreteType": "TeamMemberConnectionV2",
                "kind": "LinkedField",
                "name": "members",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TeamMemberEdgeV2",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TeamMemberV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "member",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              (v14/*: any*/),
                              (v12/*: any*/),
                              (v15/*: any*/),
                              (v4/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "65d181f4ba6169b348e6d53031c7d6ed7a6d8f25f1dc03df19467bbe1ac7e97b",
    "metadata": {},
    "name": "archiveTeamsCardQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "26e26c93c670f190365db39a8f1d9674";

export default node;
